import { render, staticRenderFns } from "./customerMgtAdminyw.vue?vue&type=template&id=374c1ed1&scoped=true&"
import script from "./customerMgtAdminyw.vue?vue&type=script&lang=js&"
export * from "./customerMgtAdminyw.vue?vue&type=script&lang=js&"
import style0 from "./customerMgtAdminyw.vue?vue&type=style&index=0&id=374c1ed1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c1ed1",
  null
  
)

export default component.exports